export const EpisodeCardVariants = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  JUMBO: 'jumbo',
} as const;

export const EpisodeCardGutterSpacing = {
  [EpisodeCardVariants.SMALL]: 3,
  [EpisodeCardVariants.MEDIUM]: 2,
  [EpisodeCardVariants.LARGE]: 2,
  [EpisodeCardVariants.JUMBO]: 3,
} as const;

export const EpisodeCardSmallDimensions = {
  width: 324,
  height: 100,
  coverImageWidth: 100,
} as const;

export const EpisodeCardMediumDimensions = {
  width: 264,
  height: 284,
  coverImageWidth: 264,
  coverImageHeight: 168,
} as const;

export const EpisodeCardLargeDimensions = {
  width: 290,
  height: 420,
} as const;

export const EpisodeCardJumboDimensions = {
  width: 650,
  height: 380,
};

export const EpisodeCardDimensions = {
  [EpisodeCardVariants.SMALL]: EpisodeCardSmallDimensions,
  [EpisodeCardVariants.MEDIUM]: EpisodeCardMediumDimensions,
  [EpisodeCardVariants.LARGE]: EpisodeCardLargeDimensions,
  [EpisodeCardVariants.JUMBO]: EpisodeCardJumboDimensions,
} as const;
